import { z } from 'zod';
/**
 * Contrat de `GET /api/health` — statut + version + hostname, consommé par la SPA
 * (bandeau version, à-propos). Sonde publique (avant login). Source unique de
 * vérité front + back.
 */
export const healthSchema = z.object({
    status: z.literal('ok'),
    name: z.string(),
    version: z.string(),
    buildId: z.string(),
    publicHostname: z.string(),
});
//# sourceMappingURL=health.js.map